(ns yardwerkz.web.router
  "Client-side routing with reitit-frontend and HTML5 pushState."
  (:require
   [reitit.frontend :as rf]
   [reitit.frontend.easy :as rfe]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [lambdaisland.glogi :as log]))

;; =============================================================================
;; Route Definitions
;; =============================================================================

(def routes
  [["/"                          {:name :home}]
   ["/book"                      {:name :book}]
   ["/jobs"                      {:name :jobs}]
   ["/jobs/:id"                  {:name :job}]
   ["/messages"                  {:name :messages}]
   ["/messages/:id"              {:name :conversation}]
   ["/profile"                   {:name :profile}]
   ["/profile/addresses"         {:name :saved-addresses}]
   ["/profile/edit"              {:name :edit-profile}]
   ["/profile/payment-methods"   {:name :payment-methods}]
   ["/profile/payment-history"   {:name :payment-history}]
   ["/profile/notifications"     {:name :notification-prefs}]])

;; =============================================================================
;; Navigation Helpers
;; =============================================================================

(defn navigate!
  "Navigate to a named route."
  ([route-name]
   (rfe/push-state route-name))
  ([route-name path-params]
   (rfe/push-state route-name path-params))
  ([route-name path-params query-params]
   (rfe/push-state route-name path-params query-params)))

(defn href
  "Generate an href string for a named route."
  ([route-name]
   (rfe/href route-name))
  ([route-name path-params]
   (rfe/href route-name path-params))
  ([route-name path-params query-params]
   (rfe/href route-name path-params query-params)))

;; =============================================================================
;; Router Initialization
;; =============================================================================

;; Route name → browser tab title
(def ^:private route-titles
  {:home "Book a Service"
   :book "Book a Service"
   :jobs "My Jobs"
   :job "Job Detail"
   :messages "Messages"
   :conversation "Chat"
   :profile "Profile"
   :saved-addresses "Saved Addresses"
   :edit-profile "Edit Profile"
   :payment-methods "Payment Methods"
   :payment-history "Payment History"
   :notification-prefs "Notifications"})

(defn on-navigate [match _history]
  (let [route-name (:name (:data match))]
    (log/debug :router/navigate {:route route-name :path (:path match)})
    ;; Update browser tab title
    (set! (.-title js/document)
          (str (get route-titles route-name "Yardwerkz") " | Yardwerkz"))
    (rfx/dispatch store/rfx-ctx [::store/set-route match])))

(defn init! []
  (log/info :router/init {})
  (rfe/start!
   (rf/router routes)
   on-navigate
   {:use-fragment false}))
